<template>
  <section style="height: fit-content">
    <div class="calendarDayItem" @click="showMultiItems()">
      <div class="calendarItem">
        <p>{{ this.events.length - this.number }} more</p>
      </div>
    </div>
    <div v-if="this.value.show && this.showMulti" class="itemBox">
      <MultiDetails :events="this.tmp" :value="this.value" />
    </div>
  </section>
</template>

<script>
import MultiDetails from "@/components/calendar/MultiDetails";
import { mapState } from "vuex";

export default {
  components: {
    MultiDetails,
  },

  props: ["events", "number"],

  data: () => ({
    value: {
      show: false,
    },
    tmp: null,
  }),

  mounted() {
    this.tmp = this.events;
  },

  computed: {
    ...mapState("calendar", ["showMulti"]),
    ...mapState("calendar", ["isAddingEvent"]),
  },

  methods: {
    showMultiItems() {
      this.value.show = true;
      this.$store.commit("calendar/setShowMulti", true);
    },
  },
};
</script>

<style scoped>
p {
  color: black;
  font-size: 12px;
  font-weight: 600;
}

.calendarItem {
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  margin: 2px;
  z-index: 20 !important;
}

.calendarItem:hover {
  background-color: #d0d0d0;
}

.itemBox {
  z-index: 200;
  width: 100%;
  padding: 10px;
  margin-top: 29px;
  transform: translateY(-100%);
  background-color: white;
  border-top: thin solid #e0e0e0;
  transition: all 0.5s ease-in-out;
}
</style>
